module.exports = __webpack_public_path__ + "img/logo.7fd45a02.png";